export enum Launch_Slots {
  "hu" = "hu",
}
